<!-- Welcome Section -->
<div class="welcome-section">
  <div class="welcome-avatar">
    <span class="avatar-initials">{{ getUserInitials() }}</span>
  </div>
  <div class="welcome-text">
    <div class="welcome-title-row">
      <h2 class="welcome-title">Welcome <span class="welcome-name">{{ displayName || username || email }}</span></h2>
      <span class="welcome-badge" *ngIf="accountCreatedDate">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
          <line x1="16" y1="2" x2="16" y2="6"></line>
          <line x1="8" y1="2" x2="8" y2="6"></line>
          <line x1="3" y1="10" x2="21" y2="10"></line>
        </svg>
        Joined {{ accountCreatedDate }}
      </span>
    </div>
  </div>
</div>

<!-- Account Information -->
<div class="profile-section">
  <div class="section-header">
    <div class="section-icon">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
        <circle cx="12" cy="7" r="4"></circle>
      </svg>
    </div>
    <h3 class="section-title">Account Information</h3>
  </div>
  
  <div class="profile-form">
    <div class="form-row">
      <div class="form-group">
        <label class="form-label">First Name</label>
        <input 
          type="text" 
          class="form-input" 
          [(ngModel)]="firstName"
          placeholder="Enter your first name"
          readonly
        />
      </div>
      <div class="form-group">
        <label class="form-label">Last Name</label>
        <input 
          type="text" 
          class="form-input" 
          [(ngModel)]="lastName"
          placeholder="Enter your last name"
          readonly
        />
      </div>
    </div>

    <div class="form-row" [class.single-column]="!hasOrganisation">
      <div class="form-group">
        <label class="form-label">
          Email Address
          <div class="label-actions">
            <button 
              type="button"
              class="copy-icon-btn"
              (click)="copyEmailToClipboard()"
              [attr.aria-label]="'Copy email'"
              title="Copy email"
            >
              <svg class="copy-icon" width="16" height="16" viewBox="0 0 24 24" fill="none">
                <rect x="9" y="9" width="13" height="13" rx="2" ry="2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span class="copy-success" *ngIf="emailCopied">Copied!</span>
            </button>
            <span class="verified-chip" *ngIf="emailVerified" title="Email verified">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
              Verified
            </span>
          </div>
        </label>
        <input 
          type="email" 
          class="form-input" 
          [(ngModel)]="email"
          placeholder="Enter your email"
          readonly
        />
      </div>

      <div class="form-group" *ngIf="hasOrganisation">
        <label class="form-label">
          Organization
          <span class="organisation-status-chip" *ngIf="organisationStatus === 'pending'" title="Organisation request is pending approval">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
              <path d="M12 16V12M12 8H12.01"></path>
            </svg>
            Pending
          </span>
          <span class="organisation-status-chip organisation-status-chip--granted" *ngIf="organisationStatus === 'granted'" title="Organisation request has been granted">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
            Granted
          </span>
        </label>
        <input 
          type="text" 
          class="form-input" 
          [value]="organisationName"
          readonly
        />
      </div>
    </div>
  </div>
</div>

<!-- Account Actions -->
<div class="profile-section">
  <div class="section-header">
    <div class="section-icon">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
        <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
      </svg>
    </div>
    <h3 class="section-title">Security & Access</h3>
  </div>

  <div class="action-buttons">
    <button class="action-btn action-btn--primary" (click)="handleGetCredentials()" [disabled]="loadingCredentials">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" *ngIf="!loadingCredentials">
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
        <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
      </svg>
      <span *ngIf="loadingCredentials">Loading...</span>
      <span *ngIf="!loadingCredentials">Get Credentials</span>
    </button>

    <button class="action-btn action-btn--secondary" (click)="handleChangePassword()">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M21.5 2v6h-6M2.5 22v-6h6M2 11.5a10 10 0 0 1 18.8-4.3M22 12.5a10 10 0 0 1-18.8 4.2"></path>
      </svg>
      <span>Change Password</span>
    </button>
  </div>
</div>

<!-- Consent Management -->
<div class="profile-section">
  <div class="section-header">
    <div class="section-icon">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
      </svg>
    </div>
    <h3 class="section-title">Consent Management</h3>
  </div>

  <div class="consent-cards">
    <!-- Privacy Policy Consent -->
    <div class="consent-card">
      <div class="consent-content">
        <h4 class="consent-title">Privacy Policy Consent</h4>
        <p class="consent-description">
          You have granted consent to the NHA platform to collect and process your personal data in accordance with the Privacy Policy. You can revoke this consent at any time.
        </p>
        <div class="consent-actions">
          <button class="link-btn" (click)="viewPrivacyPolicy()">View Privacy Policy</button>
          <button class="link-btn link-btn--danger" (click)="handleRevokePrivacyConsent()" *ngIf="!isAdmin">Revoke Consent</button>
        </div>
      </div>
    </div>

    <!-- Terms of Service Consent -->
    <div class="consent-card">
      <div class="consent-content">
        <h4 class="consent-title">Terms of Service Consent</h4>
        <p class="consent-description">
          You have agreed to abide by the NHA platform's Terms of Service. If you no longer wish to be bound by these terms, you may revoke your consent.
        </p>
        <div class="consent-actions">
          <button class="link-btn" (click)="viewTermsOfService()">View Terms of Service</button>
          <button class="link-btn link-btn--danger" (click)="handleRevokeTermsConsent()" *ngIf="!isAdmin">Revoke Consent</button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Danger Zone -->
<div class="profile-section danger-section" *ngIf="!isCosAdmin">
  <div class="danger-content">
    <div class="danger-warning">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" y1="8" x2="12" y2="12"></line>
        <line x1="12" y1="16" x2="12.01" y2="16"></line>
      </svg>
      <div>
        <h4 class="danger-title">Delete Account</h4>
        <p class="danger-description">Once you delete your account, there is no going back. Please be certain.</p>
      </div>
    </div>
    <button class="action-btn action-btn--danger" (click)="handleDeleteAccount()">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="3 6 5 6 21 6"></polyline>
        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
      </svg>
      <span>Delete My Account</span>
    </button>
  </div>
</div>

<!-- Delete Account Confirmation Dialog -->
<app-confirmation-dialog
  [visible]="showDeleteConfirmDialog"
  (visibleChange)="showDeleteConfirmDialog = $event"
  type="delete"
  themeColor="red"
  title="This Action Will Permanently Delete Your Account"
  [message]="getDeleteAccountMessage()"
  confirmLabel="Delete Account"
  cancelLabel="Cancel"
  [onLinkClick]="handleLinkClick"
  [loading]="loadingDeleteAccount"
  (onConfirm)="onConfirmDeleteAccount()"
  (onCancel)="showDeleteConfirmDialog = false"
></app-confirmation-dialog>

<!-- Revoke Privacy Consent Confirmation Dialog -->
<app-confirmation-dialog
  [visible]="showRevokePrivacyDialog"
  (visibleChange)="showRevokePrivacyDialog = $event"
  type="delete"
  themeColor="red"
  title="This Action Will Revoke Your Consent"
  [message]="getRevokeConsentMessage()"
  confirmLabel="Revoke Consent"
  cancelLabel="Cancel"
  [onLinkClick]="handleLinkClick"
  [loading]="loadingRevokePrivacy"
  (onConfirm)="onConfirmRevokePrivacy()"
  (onCancel)="showRevokePrivacyDialog = false"
></app-confirmation-dialog>

<!-- Revoke Terms Consent Confirmation Dialog -->
<app-confirmation-dialog
  [visible]="showRevokeTermsDialog"
  (visibleChange)="showRevokeTermsDialog = $event"
  type="delete"
  themeColor="red"
  title="This Action Will Revoke Your Consent"
  [message]="getRevokeConsentMessage()"
  confirmLabel="Revoke Consent"
  cancelLabel="Cancel"
  [onLinkClick]="handleLinkClick"
  [loading]="loadingRevokeTerms"
  (onConfirm)="onConfirmRevokeTerms()"
  (onCancel)="showRevokeTermsDialog = false"
></app-confirmation-dialog>

<!-- Change Password Modal -->
<div class="modal-overlay" *ngIf="showChangePasswordModal" (click)="closeChangePasswordModal()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3 class="modal-title">Change Password</h3>
      <button class="modal-close" (click)="closeChangePasswordModal()" type="button">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>
    
    <form [formGroup]="changePasswordForm" (ngSubmit)="onSubmitChangePassword()" class="modal-body">
      <div class="form-group">
        <label class="form-label" for="newPassword">
          New Password
          <span class="required-asterisk">*</span>
        </label>
        <input
          type="password"
          id="newPassword"
          formControlName="newPassword"
          class="form-input"
          [class.error]="newPasswordControl?.invalid && newPasswordControl?.touched && !allPasswordCriteriaMet"
          placeholder="Enter new password"
        />
        
        <!-- Password Criteria List -->
        <div class="password-criteria" *ngIf="newPasswordControl?.value">
          <div class="criterion-item" [class.met]="passwordCriteria.length">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline *ngIf="passwordCriteria.length" points="20 6 9 17 4 12"></polyline>
              <line *ngIf="!passwordCriteria.length" x1="18" y1="6" x2="6" y2="18"></line>
              <line *ngIf="!passwordCriteria.length" x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
            <span>Minimum number of characters is 8 and maximum is 20.</span>
          </div>
          <div class="criterion-item" [class.met]="passwordCriteria.lowercase">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline *ngIf="passwordCriteria.lowercase" points="20 6 9 17 4 12"></polyline>
              <line *ngIf="!passwordCriteria.lowercase" x1="18" y1="6" x2="6" y2="18"></line>
              <line *ngIf="!passwordCriteria.lowercase" x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
            <span>Should contain lowercase.</span>
          </div>
          <div class="criterion-item" [class.met]="passwordCriteria.uppercase">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline *ngIf="passwordCriteria.uppercase" points="20 6 9 17 4 12"></polyline>
              <line *ngIf="!passwordCriteria.uppercase" x1="18" y1="6" x2="6" y2="18"></line>
              <line *ngIf="!passwordCriteria.uppercase" x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
            <span>Should contain uppercase.</span>
          </div>
          <div class="criterion-item" [class.met]="passwordCriteria.number">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline *ngIf="passwordCriteria.number" points="20 6 9 17 4 12"></polyline>
              <line *ngIf="!passwordCriteria.number" x1="18" y1="6" x2="6" y2="18"></line>
              <line *ngIf="!passwordCriteria.number" x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
            <span>Should contain numbers.</span>
          </div>
          <div class="criterion-item" [class.met]="passwordCriteria.specialChar">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline *ngIf="passwordCriteria.specialChar" points="20 6 9 17 4 12"></polyline>
              <line *ngIf="!passwordCriteria.specialChar" x1="18" y1="6" x2="6" y2="18"></line>
              <line *ngIf="!passwordCriteria.specialChar" x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
            <span>Should contain special characters.</span>
          </div>
        </div>
      </div>

      <div class="form-group">
        <label class="form-label" for="confirmPassword">
          Confirm New Password
          <span class="required-asterisk">*</span>
        </label>
        <input
          type="password"
          id="confirmPassword"
          formControlName="confirmPassword"
          class="form-input"
          [class.error]="(confirmPasswordControl?.invalid || changePasswordForm.hasError('passwordMismatch')) && confirmPasswordControl?.touched"
          placeholder="Confirm new password"
        />
        <div class="error-message" *ngIf="confirmPasswordControl?.invalid && confirmPasswordControl?.touched">
          <span *ngIf="confirmPasswordControl?.errors?.['required']">Please confirm your password</span>
        </div>
        <div class="error-message" *ngIf="changePasswordForm.hasError('passwordMismatch') && confirmPasswordControl?.touched">
          Passwords do not match
        </div>
      </div>
    </form>

    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-secondary"
        (click)="closeChangePasswordModal()"
        [disabled]="loadingPasswordChange"
      >
        Cancel
      </button>
      <button
        type="button"
        class="btn btn-primary"
        (click)="onSubmitChangePassword()"
        [disabled]="changePasswordForm.invalid || !allPasswordCriteriaMet || loadingPasswordChange"
      >
        <span *ngIf="loadingPasswordChange">Changing...</span>
        <span *ngIf="!loadingPasswordChange">Change Password</span>
      </button>
    </div>
  </div>
</div>
